import type { IconProps } from './types';
import './icons.css';

export default function Lock({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      width={width || 24}
      height={height || 24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={`icon icon-lock ${className || ''}`}
      fill="none"
    >
      <path
        fill="currentColor"
        d="M12 2a5 5 0 0 1 5 5v1.019c.067.003.133.006.195.011.396.033.789.104 1.167.297a3 3 0 0 1 1.31 1.31c.194.379.265.772.298 1.168.031.383.03.852.03 1.395v5.6c0 .543.001 1.012-.03 1.395-.033.395-.104.789-.297 1.167a3 3 0 0 1-1.31 1.31c-.379.194-.772.265-1.168.298-.383.031-.852.03-1.395.03H8.2c-.543 0-1.012.001-1.395-.03-.396-.033-.789-.104-1.167-.297a3 3 0 0 1-1.31-1.31c-.194-.379-.265-.773-.298-1.168C4 18.812 4 18.343 4 17.8v-5.6c0-.543-.001-1.012.03-1.395.033-.396.104-.789.297-1.167a3 3 0 0 1 1.31-1.31c.379-.194.772-.265 1.168-.298.062-.005.128-.008.195-.011V7a5 5 0 0 1 5-5Zm-3.8 8c-.576 0-.949.001-1.232.024-.272.023-.373.06-.422.085a1 1 0 0 0-.437.437c-.025.05-.062.15-.085.422C6.001 11.25 6 11.624 6 12.2v5.6c0 .576.001.949.024 1.232.023.272.06.373.085.422a1 1 0 0 0 .437.437c.05.025.15.062.422.085.283.023.656.024 1.232.024h7.6c.576 0 .949-.001 1.232-.024.272-.023.373-.06.422-.085a1 1 0 0 0 .437-.437c.025-.05.062-.15.085-.422.023-.283.024-.656.024-1.232v-5.6c0-.576-.001-.949-.024-1.232-.023-.272-.06-.373-.085-.422a1 1 0 0 0-.437-.437c-.05-.025-.15-.062-.422-.085A16.975 16.975 0 0 0 15.8 10H8.2Zm5.8 4a1 1 0 1 1 0 2h-4a1 1 0 0 1 0-2h4ZM12 4a3 3 0 0 0-3 3v1h6V7a3 3 0 0 0-3-3Z"
      />
    </svg>
  );
}
